import React from 'react'
import styled from 'styled-components'
import {Link} from 'react-router-dom'
import {images} from '../../../pages/Homepage/data'


const CardWrapper = styled.div`
    width: 100%;
    height: 100%;
    text-align: center;
    background-color: #303030;
    border-radius: 30px;
    padding: 40px;
    @media screen and (max-width: 576px) {
        width: 44vw;
        margin: 0 auto;
        padding: 10px;
    }
    @media screen and (max-width: 480px) {
        width: 40vw;
        padding: 5px;
    }
`

const Image = styled.img`
    display: inline-block;
    width: 20vw;
    max-width: 400px;
    @media screen and (max-width: 768px) {
        width: 30vw;
    }
`

const DescriptionWrapper = styled.div`
    text-align: left;
    margin: 5vh 0;
`

const KitTitle = styled.h2`
display: inline-block;
width: fit-content;
color: ${({color}) => (color==='') ? '#fff' : color};
background-color: ${({bg_color}) => (bg_color==='') ? 'inherit' : bg_color};
font-family: ${({font}) => (font==='') ? 'inherit' : font};
font-size: 48px;
line-height: 0.3;
font-weight: bold;
margin-bottom: 5vh;

@media screen and (max-width: 768px) {
    font-size: 36px;
}
`

const Description = styled.p`
margin-bottom: 5vh;
font-size: 24px;
@media screen and (max-width: 768px) {
    font-size: 12px;
}
`

const Button = styled(Link)`
display: flex;
align-items: center;
justify-content: center;
width: 190px;
height: 70px;
margin-top: 4vh;
border: 2px solid ${({color}) => color};
color: #fff;
background-color: inherit;
font-family: ${({font}) => (font==='') ? 'inherit' : font};
font-size: 24px;
text-align: center;
text-decoration: none;
cursor: pointer;
opacity: 0.9;
align-self: ${({img_first}) => img_first ? 'inherit' : 'flex-end'};

@media screen and (max-width: 768px) {
    margin: 0 auto;
    width: 150px;
    height: 50px;
    font-size: 15px;
    line-height: 3vh;
    padding: 0.27vh 0;
}

@media screen and (max-width: 480px) {
    font-size: 10px;
    width: 90px;
    height: 40px;
}



&:hover, &:active {
    text-decoration: none;
    color: white;
}

&:hover{
    text-decoration: none;

    background-color: ${({color}) => color};
    opacity: 1;
}

&:active{
    background-color: ${({color}) => color};
    opacity: 1.2;
}

`





const AdsCard = ({props}) => {

    const titles = props.title.map((data) => {
        return(<KitTitle key={data.id} {...data}>{data.text}</KitTitle>)
    })


    return (
        <>
        <CardWrapper>
            <Image  src={images[props.imgID]}/>
            <DescriptionWrapper>
                {titles}
                <Description>{props.desc_text}</Description>
                <Button to={"/"+props.imgID+"Details"} {...props.button}>{props.button.text}</Button>
            </DescriptionWrapper>
        </CardWrapper>
        </>
    )
}

export default AdsCard
